import React from 'react'
import adminServices from '@/shared/assets/AdminServices.webp'
import { ReactComponent as Browser } from '@/shared/assets/browser.svg'
import { ReactComponent as Cloud } from '@/shared/assets/cloud.svg'
import { ReactComponent as Data } from '@/shared/assets/data.svg'
import { ReactComponent as User } from '@/shared/assets/user.svg'
import { ReactComponent as EasyLaunch } from '@/shared/assets/EasyLaunch.svg'
import adminBg from '@/shared/assets/adminServiceBG.webp'
import blurBG from '@/shared/assets/launchBlur.webp'
import miniPC from '@/shared/assets/miniPC.webp'

import cls from './AdminServices.module.scss'

export const AdminServices = () => {
    const preferences = [
        {
            icon: <Browser />,
            title: 'Сonvenient and \nintuitive interface',
        },
        {
            icon: <Cloud />,
            title: 'Сloud \nsolutions',
        },
        {
            icon: <Data />,
            title: 'Storage and Managing \nof your data',
        },
        {
            icon: <User />,
            title: 'Сloud \nsolutions',
        },
    ]
    return (
        <section
            id="adminservices"
            className={cls.AdminServices}
        >
            <h1 className={cls.title}>Admin Services</h1>
            <img
                src={adminBg}
                alt="Admin Services background"
                className={cls.bgGlow}
            />
            <div className={cls.imageWrapper}>
                <img
                    src={adminServices}
                    alt="Admin Services"
                />
            </div>
            <article className={cls.preferences}>
                {preferences.map((preference) => (
                    <div className={cls.preference}>
                        {preference.icon}
                        <h2>{preference.title}</h2>
                    </div>
                ))}
            </article>
            <article className={cls.EasyLaunch}>
                <EasyLaunch className={cls.icon} />
                <div className={cls.text}>
                    <h1>Easy launch</h1>
                    <p>
                        Our software seamlessly integrates with
                        <br /> any hardware, including bill acceptors,
                        <br /> ensuring a smooth launch.
                    </p>
                    <p>
                        Maximum stability and reliability
                        <br /> downtime and enhance the user
                        <br /> experience.
                    </p>
                </div>
                <div className={cls.imgContainer}>
                    <img
                        src={miniPC}
                        alt="miniPC"
                    />
                    <img
                        src={blurBG}
                        alt="blurBG"
                        className={cls.blur}
                    />
                </div>
            </article>
        </section>
    )
}
